import styled from "styled-components/macro";

import type { ThemeProps } from "models/styles/theme";

import { CssButton, CssFlex, CssInput } from "styles/helpers/layout";

export const StyledSuccessBanner = styled(CssFlex)`
  background: ${(props: ThemeProps) => props.theme.palette.feedback.success._950};
  border-radius: 0.5rem;
  padding: 0.75rem 1.5rem;
  text-align: center;
`;

export const StyledTipsBox = styled(CssFlex)`
  background: ${(props: ThemeProps) => props.theme.palette.neutral._999};
  border-radius: 0.5rem;
  padding: 1rem 1.5rem;

  ul {
    margin: 0;

    li {
      font-size: ${(props: ThemeProps) => props.theme.font.size._14};
    }
  }
`;

export const StyledInviteInput = styled(CssInput)`
  background-color: ${(props: ThemeProps) => props.theme.palette.neutral._950};
  border-color: ${(props: ThemeProps) => props.theme.palette.neutral._900};
  height: 2.25rem;
  border-radius: 4px;
  border: unset;
`;

export const StyledNarrowButton = styled(CssButton)`
  height: 2.25rem;
  font-weight: 400;
  font-size: 0.875rem;
  padding: 0.25rem 1rem;
`;
